import firebase from '../../../../../../firebase';

const reportError = err => ({
  type: 'REARRANGE_COMPONENTS_ERROR',
  err,
});

const findIndex = (array, element) => {
  if (element === null) {
    return array.length;
  }

  return array.indexOf(element);
};

const moveArray = (oldIndex, newIndex, arr) => {
  arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
  return arr;
};

export const rearrangeComponents = (
  id,
  siblingId,
  page,
  appname,
) => dispatch => {
  dispatch({
    type: 'REARRANGE_COMPONENTS',
    id,
    siblingId,
    page,
    appname,
  });

  const componentsRef = firebase
    .database()
    .ref(`apps/${appname}/draft/always_data/${page}/components`);

  componentsRef
    .transaction(compArray => {
      if (compArray === null) return null;

      const oIndex = findIndex(compArray, id);
      let nIndex = findIndex(compArray, siblingId);

      if (nIndex > oIndex) {
        nIndex -= 1;
      }

      return moveArray(oIndex, nIndex, compArray);
    })
    .catch(err => dispatch(reportError(err)));
};

export const rearrangeTabComponents = (
  id,
  siblingId,
  tab,
  page,
  appname,
) => dispatch => {
  dispatch({
    type: 'REARRANGE_TAB_COMPONENTS',
    id,
    siblingId,
    page,
    tab,
    appname,
  });

  const componentsRef = firebase
    .database()
    .ref(`apps/${appname}/draft/always_data/${page}/tabs/${tab}/components`);

  componentsRef
    .transaction(compArray => {
      if (compArray === null) return null;

      const oIndex = findIndex(compArray, id);
      let nIndex = findIndex(compArray, siblingId);

      if (nIndex > oIndex) {
        nIndex -= 1;
      }

      return moveArray(oIndex, nIndex, compArray);
    })
    .catch(err => dispatch(reportError(err)));
};

const getPageComponentKeys = pageData => {
  if (!pageData) return [];

  let keys = pageData.components || [];
  if (Array.isArray(pageData.tabs)) {
    pageData.tabs.forEach(tab => {
      if (tab && Array.isArray(tab.components)) {
        keys = keys.concat(tab.components);
      }
    });
  }
  return [...new Set(keys.filter(Boolean))];
};

// Only fetch lazy payloads for the open page — never the entire lazy_data tree.
export const getAllLazyData = (appname, pageKey) => (dispatch, getState) => {
  let page = pageKey;
  if (!page) {
    try {
      page = new URLSearchParams(window.location.search).get('page');
    } catch (e) {
      page = null;
    }
  }
  if (!page) return Promise.resolve();

  const state = getState();
  const pageData = state.editor.data.alwaysData[page];
  if (!pageData) return Promise.resolve();

  const componentKeys = getPageComponentKeys(pageData);
  const lazyIds = componentKeys
    .map(key => {
      const component = state.editor.data.alwaysData[key];
      return component && component.lazy_data;
    })
    .filter(id => id && state.editor.data.lazyData[id] === undefined);

  if (!lazyIds.length) return Promise.resolve();

  const lazyDataRef = firebase
    .database()
    .ref(`apps/${appname}/draft/lazy_data`);

  return Promise.all(
    lazyIds.map(id =>
      lazyDataRef
        .child(id)
        .once('value')
        .then(snapshot => {
          if (snapshot.exists()) {
            dispatch({
              type: 'RECEIVE_LAZY_DATA',
              data: snapshot.val(),
              key: id,
            });
          }
        }),
    ),
  );
};

export const duplicateComponentDialog = component => dispatch => {
  dispatch({ type: 'OPEN_DUPLICATE_COMPONENT_DIALOG' });
  dispatch({ type: 'SET_DUPLICATE_COMPONENT', payload: component });
};
